import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyConnectGeneralRoute: InvariantJiraRoute = {
	name: 'legacy-connect-general',
	path: '/plugins/servlet/ac/:addonKey/:moduleKey',
};
